import type {
  AgentDelegationEndedReason,
  AgentDelegationErrorCode,
  AgentDelegationEvent,
  AgentDelegationKind,
  AgentDelegationStatus,
  AgentDelegationTaskType,
  LocalCodingAgentRuntime,
} from './agentDelegation';
import type {
  DelegationBlockedReason,
  PullRequestChecksStatus,
  PullRequestReviewDecision,
  PullRequestState,
} from './doboxExecutor';

export enum AgentRunEndReason {
  REPLACED = 'REPLACED',
  ENDED_BY_USER = 'ENDED_BY_USER',
}

export const MAX_AGENT_RUN_HISTORY_RUNS = 20;
export const AGENT_RUN_SUMMARY_MAX_BYTES = 4096;
export const AGENT_RUN_HISTORY_MAX_BYTES = 49152;
export const AGENT_RUN_SUMMARY_ERROR_MAX_LENGTH = 500;
export const MAX_AGENT_RUN_SUMMARY_EVENTS = 20;

/** One archived delegation lifecycle. Leaves out the plan, any pending question or approval,
 *  the job log tail and the repository slug on purpose. */
export interface AgentRunSummary {
  /** The archived delegation's `delegationId`. */
  id: string;
  kind: AgentDelegationKind;
  taskType: AgentDelegationTaskType;
  targetName: string;
  agentTemplateId?: string;
  localRuntime?: LocalCodingAgentRuntime;
  localModel?: string;
  localAgentProfile?: string;
  delegatedByUserId?: string;
  status: AgentDelegationStatus;
  blockedReason?: DelegationBlockedReason;
  endedReason?: AgentDelegationEndedReason;
  answeredInTextOnly?: boolean;
  endReason: AgentRunEndReason;
  startedAt: number;
  finishedAt?: number;
  archivedAt: number;
  prUrl?: string;
  prNumber?: number;
  prState?: PullRequestState;
  prChecksStatus?: PullRequestChecksStatus;
  prChecksFailedCount?: number;
  prReviewDecision?: PullRequestReviewDecision;
  prReviewCommentCount?: number;
  prSignalsUpdatedAt?: number;
  errorCode?: AgentDelegationErrorCode;
  statusMessage?: string;
  error?: string;
  executionLog?: AgentDelegationEvent[];
  runId?: string;
  conversationId?: string;
  ledgerConversationId?: string;
  mcpConnectionId?: string;
  jobId?: string;
  deviceId?: string;
  dispatchClaimId?: string;
}
